/**
 * Navigation translations - English
 */

export default {
  home: 'Home',
  coreService: 'Core Services',
  industrySolutions: 'Industry Solutions',
  caseStudies: 'Case Studies',
  resourceCenter: 'Resource Center',
  customerSupport: 'Customer Support',
  about: 'About Us',
  contact: 'Contact Us',
  search_placeholder: 'Have technical questions? Our AI engine can help you.'
}

